import { observable, computed, action } from "mobx";
import { PulseBetMarketAdditionalData, BasicPulseBetViewModel } from "../../ViewModel";
import { StakeViewModel, FreeBetDispatchData } from "../../../../blocks/PulseBetMarkets/data";
import { WinningsDataModel } from "../../WinningsDataModel";
import { CalculatedPeriod } from "../CalculatedPeriod/CalculatedPeriod";
import { PulseFreeBetInfo } from "../../PulseFreeBetInfo";
import { DropdownData } from "sb-resp-ui";
import { BonusInfo } from "../../BonusInfo";

export class PulseBetMarketComponentData extends BasicPulseBetViewModel {

    private eventsManager: EventsManager;
    private prevStakeValue: number;
    @observable onStakeChangeFading: boolean;
    public externalPlaceBetHandler: () => void;

    stakeInputData: StakeViewModel;
    @observable freeBetsEnabled: boolean;
    @observable winings: WinningsDataModel;
    @observable freePulseBets: PulseFreeBetInfo;

    constructor(stakeInputData: StakeViewModel, pulseBetMetadata: PulseBetMarketAdditionalData, gameProgressInMilli: number, freePulseBets: PulseFreeBetInfo,
        placeBetHandler?: () => void) {
        super(stakeInputData.stakeValue, pulseBetMetadata, gameProgressInMilli);
        this.prevStakeValue = stakeInputData.stakeValue;
        this.eventsManager = new EventsManager();
        this.stakeInputData = stakeInputData;
        this.placeBetHandler = this.placeBetHandler.bind(this);
        this.externalPlaceBetHandler = placeBetHandler ? placeBetHandler : () => { };
        this.onStakeChangeFading = false;
        this.freePulseBets = freePulseBets;
        this.freeBetsEnabled = false;

        let count = 1;
        this.winings = {
            winnings: this.wrappedCalculatedPeriods.map(period => (
                {
                    winningValue: period.formatedWin,
                    winningStatus:/*istanbul ignore next */ period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                    periodNumber: count++
                })),
            branchID: this.pulseBetMetadata.branchID
        };
    }

    private setWiningsBy(freePulseBetId: string) {
        let selectedFreeBet = this.freePulseBets.bonusInfo.find(x => x.bonusId === freePulseBetId);
        if (selectedFreeBet) {
            this.freePulseBets.selectedFreeBetId = selectedFreeBet.bonusId;
            this.stakeInputData.stakeValue = selectedFreeBet.amount;
            this.setWinings(selectedFreeBet.amount, selectedFreeBet);
        }
    }

    private setWinings(amount: number, bonusInfo?: BonusInfo) {
        let periods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(amount, this.pulseBetMetadata, bonusInfo);
        this.winings.winnings = periods.map((period, index) => (
            {
                winningValue: period.formatedWin,
                winningStatus: /*istanbul ignore next */ period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                periodNumber: index
            }));
        this.onStakeChangeFading = true;
        this.eventsManager.dispatchEvent("onSetStake", { marketTypeId: this.pulseBetMetadata.typeId }, true);
    }

    @computed get wrappedCalculatedPeriods(): CalculatedPeriod[] {

        let bonusInfo;
        if (this.freePulseBets && this.freePulseBets.selectedFreeBetId) {
            bonusInfo = this.freePulseBets.bonusInfo.find(x => x.bonusId === this.freePulseBets.selectedFreeBetId);
        }
        return this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(this.stakeInputData.stakeValue, this.pulseBetMetadata, bonusInfo);
    }

    @computed get periodFrames() {
        return this.wrappedCalculatedPeriods.map(p => p.relativeRangeFormatted);
    }

    @computed get hasFreeBetOptions(): boolean {
        return this.freeBetOptions.length > 0;
    }

    @computed get hasSelectedFreeBet(): boolean {
        return this.freePulseBets.bonusInfo.some(v => v.bonusId === this.freePulseBets.selectedFreeBetId);
    }

    @computed get freeBetOptions(): DropdownData {
        return this.freePulseBets.bonusInfo.map((v, i) => ({
            id: v.bonusId,
            text: v.title,
            isSelected: this.hasSelectedFreeBet ? v.bonusId === this.freePulseBets.selectedFreeBetId : i === 0
        }));

    }

    @action.bound updateFreePulseBets(newBonusInfo: BonusInfo[]) {
        if (!newBonusInfo.find(x => x.bonusId === this.freePulseBets.selectedFreeBetId)) {
            this.freePulseBets.selectedFreeBetId = "";
        }
        (this.freePulseBets.bonusInfo).replace(newBonusInfo);
    }

    @action.bound onFreePulseBetSelect(selectedFreeBetId) {
        this.setWiningsBy(selectedFreeBetId);
        let dispatchData: FreeBetDispatchData = {
            marketTypeId: this.freePulseBets.marketTypeId,
            freeBetId: selectedFreeBetId
        }
        this.eventsManager.dispatchEvent("onFreePulseBetSelect", dispatchData, true);
    }

    @action.bound toggleStakeType() {
        this.freeBetsEnabled = !this.freeBetsEnabled;

        if (this.freeBetsEnabled) {
            let tempValue = this.prevStakeValue;
            this.prevStakeValue = this.stakeInputData.stakeValue;
            this.stakeInputData.stakeValue = tempValue;
            if (this.freeBetOptions && this.freeBetOptions[0]) {
                this.onFreePulseBetSelect(this.freeBetOptions[0].id);
            }
            else {
                this.setWinings(this.stakeInputData.stakeValue);
            }
        }
        else {
            this.stakeInputData.stakeValue = this.prevStakeValue;

            if (this.freePulseBets.selectedFreeBetId) {
                this.resetFreePulseBets();
            }

            this.setWinings(this.stakeInputData.stakeValue);
        }
    }

    @action resetFreePulseBets() {
        this.freePulseBets.selectedFreeBetId = "";
        this.onFreePulseBetSelect(this.freePulseBets.selectedFreeBetId);
    }

    placeBetHandler() {
        // it's overriden in constructor and in PulseBettingStore
    }

}